/**
* 系统管理 角色管理
*/
<template>
  <div class="role">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="角色ID：">
        <el-input size="small" v-model="formInline.role_id" placeholder="输入角色ID"></el-input>
      </el-form-item>
      <el-form-item label="角色名称：">
        <el-input size="small" v-model="formInline.role_name" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'roleauth.list'">搜索
        </el-button>
        <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
          v-auth="'roleauth.addorupdate'">添加角色</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="el-table-con">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="role_id" label="角色ID">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="role_name" label="角色名称">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="user_qty" label="用户数量">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="remark" label="备注">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'roleauth.addorupdate'">编辑</el-button>
            <el-button size="mini" type="success" @click="modulePower(scope.row)"
              v-auth="'roleauth.updaterolemodulerights'">模块权限</el-button>
            <el-button size="mini" type="success" @click="dataPower(scope.row)"
              v-auth="'roleauth.updaterolemodulerights'">数据权限</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="角色ID" prop="role_id" v-if="editForm.role_id">
          <el-input size="small" v-model="editForm.role_id" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="role_name">
          <el-input size="small" v-model="editForm.role_name" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 模块权限 -->
    <el-dialog title="模块权限" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all="" :data="RoleRight" node-key="module_code" :props="RoleRightProps"
        check-on-click-node :default-checked-keys="checkmenu" check-strictly show-checkbox
        @check-change="handleCheckChange" @check="clickDeal">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  let change = [];
  var rules = [];
  import {
    menu,
    roleList,
    roleInfo,
    roleSave,
    RoleRightTree,
    RoleRightSave
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    inject: ['reload'],
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        menuAccessshow: false, //控制数据权限显示与隐藏
        title: '添加角色',
        editForm: {
          role_id: '',
          role_name: '',
          remark: '',
        },
        // rules 表单验证
        rules: {
          role_id: [
            { required: true, message: '请输入角色ID', trigger: 'blur' }
          ],
          role_name: [
            { required: true, message: '请输入角色名称', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' }
          ]
        },
        formInline: {
          pageindex: 1,
          pagesize: 20,
          role_id: '',
          role_name: '',
          orderby: ''
        },
        listData: [], //角色数据
        // 数据权限
        RoleRight: [],
        RoleRightProps: {
          children: 'modulelist',
          label: 'module_name'
        },
        // 选中
        checkmenu: [],
        //参数role
        saveroleId: '',
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    watch: {},

    /**
     * 创建完毕
     */

    created() { },

    mounted() {
      var formInline = localStorage.getItem('role')
      if (formInline) {
        this.formInline = JSON.parse(formInline)
      }
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取角色列表
      getdata(parameter) {
        var that = this;
        that.loading = true
        roleList(parameter)
          .then(res => {
            that.loading = false
            if (res.statusCode == 200) {
              that.listData = res.data.datas
              // 分页赋值
              that.pageparm.currentPage = res.data.pageindex
              that.pageparm.pageSize = res.data.pagesize
              that.pageparm.total = res.data.rowscount
            } else {
              that.$message.error(res.message)
            }
          })
      },
      // 获取角色信息
      getroleInfo(id) {
        var that = this;
        roleInfo({ role_id: id }).then(res => {
          if (res.statusCode == 200) {
            that.editForm = res.data;
          } else {
            that.$message.error(res.message)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageindex = parm.currentPage
        this.formInline.pagesize = parm.pageSize
        localStorage.setItem('role', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 排序
      sortChange(column, prop, order) {
        var order = '';
        if (column.order == 'ascending') {
          order = 'asc'
        } else if (column.order == 'descending') {
          order = 'desc'
        }
        if (order) {
          this.formInline.orderby = column.prop + ' ' + order
          this.search();
        }
      },
      // 搜索事件
      search() {
        this.formInline.pageindex = 1;
        localStorage.setItem('role', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 重置
      reset() {
        this.formInline = {
          pageindex: 1,
          pagesize: 20,
          role_id: '',
          role_name: '',
          orderby: ''
        }
        // 重置清掉本地搜索缓存
        localStorage.removeItem('role')
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改角色'
          this.getroleInfo(row.role_id);
        } else {
          this.title = '添加角色'
          this.editForm = {
            role_id: '',
            role_name: '',
            remark: ''
          }
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        var that = this;
        this.$refs[editData].validate(valid => {
          if (valid) {
            var editForm = that.editForm
            // 添加没有role_id
            if (!editForm.role_id) {
              delete editForm.role_id
            }
            roleSave(editForm)
              .then(res => {
                that.editFormVisible = false
                if (res.statusCode == 200) {
                  // 添加用户时清空搜索条件
                  if (that.title == '添加角色') {
                    that.reset();
                  } else {
                    that.getdata(that.formInline)
                  }
                  that.$message({
                    type: 'success',
                    message: that.title + '成功！'
                  })
                } else {
                  that.$message.error(res.message)
                }
              })
          } else {
            return false
          }
        })
      },
      // 模块权限
      modulePower(row) {
        var that = this;
        that.loading = true
        that.menuAccessshow = true
        that.saveroleId = row.role_id
        RoleRightTree({ role_id: row.role_id })
          .then(res => {
            that.loading = false
            if (res.statusCode == 200) {
              that.changemenu(res.data)
              that.RoleRight = res.data
            } else {
              that.$message.error(res.message)
            }
          })
      },
      // 选中菜单
      changemenu(arr) {
        this.changemenuTree(arr)
      },
      changemenuTree(data) {
        var that = this;
        data.forEach(item => {
          if (item.authorized) {
            change.push(item.module_code)
          }
          // 递归，如果有子元素modulelist则调用自身
          if (item.modulelist) {
            that.changemenuTree(item.modulelist)
          }
        });
        that.checkmenu = change
      },
      handleCheckChange(data, checked) {
        change = [];
        this.recursionTree(this.RoleRight, data, checked);
        this.changemenu(this.RoleRight)
      },

      //tree 父关联子不关联父样式---开始
      clickDeal(currentObj, treeStatus) {
        // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
        let selected = treeStatus.checkedKeys.indexOf(currentObj.module_code) // -1未选中
        // 选中
        if (selected !== -1) {
          // 子节点只要被选中父节点就被选中
          this.selectedParent(currentObj)
          // 统一处理子节点为相同的勾选状态
          this.uniteChildSame(currentObj, true)
        } else {
          // 未选中 处理子节点全部未选中
          if (currentObj.modulelist && currentObj.modulelist.length !== 0) {
            this.uniteChildSame(currentObj, false)
          }
        }
      },
      // 统一处理子节点为相同的勾选状态
      uniteChildSame(treeList, isSelected) {
        this.$refs.tree.setChecked(treeList.module_code, isSelected)
        treeList.authorized = isSelected;
        if (treeList.modulelist) {
          for (let i = 0; i < treeList.modulelist.length; i++) {
            this.uniteChildSame(treeList.modulelist[i], isSelected)
          }
        }
      },
      // 统一处理父节点为选中
      selectedParent(currentObj) {
        let currentNode = this.$refs.tree.getNode(currentObj)
        if (currentNode.parent.key !== undefined) {
          this.$refs.tree.setChecked(currentNode.parent, true)
          this.selectedParent(currentNode.parent)
        }
      },
      //tree 父关联子不关联父样式---结束

      recursionTree(Arrlist, data, checked) {
        var that = this;
        Arrlist.map(item => {
          if (item.module_code == data.module_code) {
            item.authorized = checked;
          }
          // 递归，如果有子元素modulelist则调用自身
          if (item.modulelist) {
            that.recursionTree(item.modulelist, data, checked)
          }
        });
      },
      // 模块权限-保存
      menuPermSave() {
        let parm = {
          role_id: this.saveroleId,
          rights: this.RoleRight
        }
        RoleRightSave(parm)
          .then(res => {
            if (res.statusCode == 200) {
              this.$message({
                type: 'success',
                message: '权限保存成功'
              })
              this.menuAccessshow = false
              // 更新$store.state.menu
              this.getmenu();
            } else {
              this.$message.error(res.message)
            }
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {
          this.menuAccessshow = false
        }
      },
      // 数据权限
      dataPower(row) {
        this.$router.push({ path: '/system/RolePower', query: { role_id: row.role_id } })
      },
      getmenu() {
        rules = [];
        menu().then(res => {
          if (res.statusCode == 200) {
            var allmenu = res.data.modulelist
            this.$store.commit('SET_MENU', allmenu)
            allmenu.forEach(item => {
              this.changemoduleTree(item.modulelist);
            });
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      },
      // 递归
      changemoduleTree(data) {
        data.forEach(cell => {
          if (!cell.route && rules.indexOf(cell.module_code) == -1) {
            rules.push(cell.module_code)
          }
          // 递归，如果有子元素modulelist则调用自身
          if (cell.modulelist && cell.modulelist.length) {
            this.changemoduleTree(cell.modulelist)
          }
        });
        if (rules) {
          this.$store.commit('SET_RULE', rules)
          localStorage.setItem('rules', JSON.stringify(rules))
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>
<style>
  .role .el-table-con {
    height: calc(100vh - 380px) !important;
  }

  .role .page-box {
    text-align: right !important;
  }

  /* 固定el-table头部 */
  .role .el-table {
    max-height: calc(100vh - 380px) !important;
  }

  .role .el-table__body-wrapper.is-scrolling-none {
    overflow-y: auto !important;
    max-height: calc(100vh - 465px) !important;
  }

  .role .el-dialog__body {
    max-height: 55vh;
    overflow-y: scroll;
  }

  .role .el-dialog__body::-webkit-scrollbar {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/Role.vue